class ShopByCategorySlider extends HTMLElement {
  constructor() {
    super();
    this.list = this.querySelector('.shop-by-category__list');
    this.progressFill = this.querySelector('.shop-by-category__progress-fill');

    if (!this.list || !this.progressFill) return;

    this.onScroll = this.updateProgress.bind(this);
    this.list.addEventListener('scroll', this.onScroll, { passive: true });

    this.resizeObserver = new ResizeObserver(this.onScroll);
    this.resizeObserver.observe(this.list);

    this.updateProgress();
  }

  updateProgress() {
    const maxScroll = this.list.scrollWidth - this.list.clientWidth;

    if (maxScroll <= 0) {
      this.progressFill.style.width = '100%';
      return;
    }

    const progress = ((this.list.scrollLeft + this.list.clientWidth) / this.list.scrollWidth) * 100;
    this.progressFill.style.width = `${Math.min(100, Math.max(0, progress))}%`;
  }

  disconnectedCallback() {
    this.list?.removeEventListener('scroll', this.onScroll);
    this.resizeObserver?.disconnect();
  }
}

if (!customElements.get('shop-by-category-slider')) {
  customElements.define('shop-by-category-slider', ShopByCategorySlider);
}
